import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { LegendPosition } from '@swimlane/ngx-charts';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { __values } from 'tslib';
declare var $: any;
var gdpData = { "AF": 16.63, "AL": 11.58, "DZ": 158.97, "AO": 85.81, "AG": 1.1, "AR": 351.02, "AM": 8.83, "AU": 1219.72, "AT": 366.26, "AZ": 52.17, "BS": 7.54, "BH": 21.73, "BD": 105.4, "BB": 3.96, "BY": 52.89, "BE": 461.33, "BZ": 1.43, "BJ": 6.49, "BT": 1.4, "BO": 19.18, "BA": 16.2, "BW": 12.5, "BR": 2023.53, "BN": 11.96, "BG": 44.84, "BF": 8.67, "BI": 1.47, "KH": 11.36, "CM": 21.88, "CA": 1563.66, "CV": 1.57, "CF": 2.11, "TD": 7.59, "CL": 199.18, "CN": 5745.13, "CO": 283.11, "KM": 0.56, "CD": 12.6, "CG": 11.88, "CR": 35.02, "CI": 22.38, "HR": 59.92, "CY": 22.75, "CZ": 195.23, "DK": 304.56, "DJ": 1.14, "DM": 0.38, "DO": 50.87, "EC": 61.49, "EG": 216.83, "SV": 21.8, "GQ": 14.55, "ER": 2.25, "EE": 19.22, "ET": 30.94, "FJ": 3.15, "FI": 231.98, "FR": 2555.44, "GA": 12.56, "GM": 1.04, "GE": 11.23, "DE": 3305.9, "GH": 18.06, "GR": 305.01, "GD": 0.65, "GT": 40.77, "GN": 4.34, "GW": 0.83, "GY": 2.2, "HT": 6.5, "HN": 15.34, "HK": 226.49, "HU": 132.28, "IS": 12.77, "IN": 1430.02, "ID": 695.06, "IR": 337.9, "IQ": 84.14, "IE": 204.14, "IL": 201.25, "IT": 2036.69, "JM": 13.74, "JP": 5390.9, "JO": 27.13, "KZ": 129.76, "KE": 32.42, "KI": 0.15, "KR": 986.26, "UNDEFINED": 5.73, "KW": 117.32, "KG": 4.44, "LA": 6.34, "LV": 23.39, "LB": 39.15, "LS": 1.8, "LR": 0.98, "LY": 77.91, "LT": 35.73, "LU": 52.43, "MK": 9.58, "MG": 8.33, "MW": 5.04, "MY": 218.95, "MV": 1.43, "ML": 9.08, "MT": 7.8, "MR": 3.49, "MU": 9.43, "MX": 1004.04, "MD": 5.36, "MN": 5.81, "ME": 3.88, "MA": 91.7, "MZ": 10.21, "MM": 35.65, "NA": 11.45, "NP": 15.11, "NL": 770.31, "NZ": 138, "NI": 6.38, "NE": 5.6, "NG": 206.66, "NO": 413.51, "OM": 53.78, "PK": 174.79, "PA": 27.2, "PG": 8.81, "PY": 17.17, "PE": 153.55, "PH": 189.06, "PL": 438.88, "PT": 223.7, "QA": 126.52, "RO": 158.39, "RU": 1476.91, "RW": 5.69, "WS": 0.55, "ST": 0.19, "SA": 434.44, "SN": 12.66, "RS": 38.92, "SC": 0.92, "SL": 1.9, "SG": 217.38, "SK": 86.26, "SI": 46.44, "SB": 0.67, "ZA": 354.41, "ES": 1374.78, "LK": 48.24, "KN": 0.56, "LC": 1, "VC": 0.58, "SD": 65.93, "SR": 3.3, "SZ": 3.17, "SE": 444.59, "CH": 522.44, "SY": 59.63, "TW": 426.98, "TJ": 5.58, "TZ": 22.43, "TH": 312.61, "TL": 0.62, "TG": 3.07, "TO": 0.3, "TT": 21.2, "TN": 43.86, "TR": 729.05, "TM": 0, "UG": 17.12, "UA": 136.56, "AE": 239.65, "GB": 2258.57, "US": 14624.18, "UY": 40.71, "UZ": 37.72, "VU": 0.72, "VE": 285.21, "VN": 101.99, "YE": 30.02, "ZM": 15.69, "ZW": 5.57 };
@Component({
	selector: 'app-dashboard-mhs',
	templateUrl: './dashboard-mhs.component.html',
	styleUrls: ['./dashboard-mhs.component.scss', '../../assets/styles/dashboard-styles.scss']
})
export class DashboardMhsComponent implements OnInit, AfterViewInit, OnDestroy {
	compId: any = null;
	UserModuleAccess: any = "Full";
	pieChartColors1: any[] = [];
	pieChartColors2: any[] = [];
	pieChartColors3: any[] = [];
	pieChartColors4: any[] = [];
	rankPieChartColors: any[] = [];
	rankPieChartColors1: any[] = [];
	rankPieChartColors2: any[] = [];
	rankPieChartColors3: any[] = [];
	rankChart_dataC: any[] = [];
	user_type: any = "";
	isCompanyIdNull = false;
	constructor(private formBuilder: FormBuilder, private datePipe: DatePipe, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService) { }
	filterDates = (d: Date | null) => {
		const today = new Date();
		if (d == null) return false;
		return d <= today;
	}
	view: any[] = [200, 500];
	cardsFilter: any = {
		symptom: null,
		company_id: null,
		fleet_id: null,
		rank: null,
		clinicalScale: [35, 36, 37, 44, 42],
		personalityScale: [4, 5, 33, 7, 8],
		start_date: this.apiService.getDefaultDateRange1Month(false).start_date,
		end_date: this.apiService.getDefaultDateRange1Month(false).end_date
	}
	selectedData = [4, 5, 33];
	allQuestions: any = [];
	strLimitPersonality: any = 50;
	strLimitClinical: any = 50;
	personalityScaleData: any = null;
	clinicalScaleData: any = null;
	markers: any[] = [];
	clinicalScales: any = [];
	feedbackbar1: any = [];
	feedbackbar2: any = [];
	feedbackbar3: any = [];
	feedbackbar4: any = [];
	personalityScales = [];
	personalityScalesBar: any = [];
	clinicalScalesBar: any = [];
	chart_loader = '<div class="chart_loader"></div>';
	noDataText = '<h5 style="color:maroon;text-align: center;">No data found</h5>';
	totalNoOfTest: any;
	completionTime: any;
	prejoining: any;
	prejoiningandpromotion: any;
	totalNoOfMACITest: any;
	showMoreType: any = null;
	clinicalForm!: FormGroup;
	personalityForm!: FormGroup;
	companyName: string = "";
	accessLoader = false;

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.accessLoader = true;
			this.apiService.getUserAccess().subscribe((data: any) => {
				this.accessLoader = false;
				try {
					this.user_type = data.res[0].user_type;
					let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
					this.UserModuleAccess = accessObj["MHS_dashboard"];
					if (this.user_type != 'cdm') {
						let company = data.res[0].company_id[0];
						this.cardsFilter.company_id = company;
						this.isCompanyIdNull = company.mhs_id ? false : true;
						this.getCompanyWiseData();
					} else {
						if (sessionStorage.getItem("selectedCompanyFilter")) {
							try {
								let obj = JSON.parse(sessionStorage.getItem("selectedCompanyFilter")!);
								if (obj.mhs_id) {
									this.cardsFilter.company_id = obj;
								}
							} catch (error) { }
						}
						this.getCompanyWiseData();
					}
				} catch (error) { }
			}, (error: any) => {
				this.accessLoader = false;
				this.UserModuleAccess = "NoAccess";
			});
			this.clinicalForm = this.formBuilder.group({
				clinicalScale1: [null]
			});
			this.personalityForm = this.formBuilder.group({
				personalityScale1: [null]
			});
		});
	}
	ngAfterViewInit(): void {
		/* this.bindMap(); */
	}
	ngOnDestroy(): void {
		this.removeAllMapPoint();
	}
	getCompanyWiseData() {
		// Group similar API calls for readability and optimization
		this.loadDashboardData();
		this.loadScalesData();
		this.loadDropdownData();
	}

	loadDashboardData() {
		const dashboardAPIs = [
			this.mhs_dashboard_no_candidates_per_day(),
			this.dashboard_report_status_pie_chart_data(),
			this.appointment_distribution_by_nation(),
			this.appointment_distribution_by_comp(),
			this.overview_count_data(),
			this.rank_distribution_pie_chart_data(),
			this.getFeedbackData()
		];

		// Run dashboard-related API calls in parallel
		Promise.all(dashboardAPIs).catch(error => {
			console.error('Error loading dashboard data:', error);
		});
	}

	loadScalesData() {
		const scalesAPIs = [
			this.getPersonalityScales(),
			this.getClinicalScales(),
			this.mhs_personality_and_clinical_scales()
		];

		// Run scales-related API calls in parallel
		Promise.all(scalesAPIs).catch(error => {
			console.error('Error loading scales data:', error);
		});
	}

	loadDropdownData() {
		const dropdownAPIs = [
			this.rank_dropdown(),
			this.mhs_dashboard_company_dropdown()
		];

		// Run dropdown-related API calls in parallel
		Promise.all(dropdownAPIs).catch(error => {
			console.error('Error loading dropdown data:', error);
		});
	}


	get f() { return this.clinicalForm.controls; }
	get f1() { return this.personalityForm.controls; }
	pagetitle = "Psychometry";
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: this.apiService.getDashboardURL("mhs"),
			name: this.pagetitle
		}
	];
	dateFilter = this.apiService.getDefaultDateRange(true);
	/* datePsychometry = this.apiService.getDefaultDateRange3Months(true); */

	currentAccordion = "InvoiceModuleAlerts";

	dateChanged(e: any) {
		this.dateFilter = e;
		this.accordionOpened(this.currentAccordion);
	}
	// dateFilterPsychometry(e: any){
	// 	 this.datePsychometry = e;
	// 	 console.log(e);
	// 	this.mhs_dashboard_no_candidates_per_day();
	// 	this.appointment_distribution();
	// 	this.getClinicalScales();
	// 	this.getPersonalityScales();
	// 	this.dashboard_report_status_pie_chart_data();
	// 	this.rank_distribution_pie_chart_data();
	// 	this.rank_dropdown();
	// }
	accordionOpened(id: any) {
		this.currentAccordion = id;
		if (id == 'AppointmentsCountByPsychology') {
			this.getApptCntByPsychology();
		} else if (id == 'AppointmentsNationalityDistribution') {
			this.appointmentsNationalityDistribution();
		} else if (id == 'MhsAppointmentsTotalData') {
			this.mhsAppointmentsTotalData();
		} else if (id == 'BillableAppointmentsMHS') {
			this.billableAppointmentsMHS();
		} else if (id == 'TotalFlaggedForMSE') {
			this.totalFlaggedForMSE();
		} else if (id == 'TotalPendingReports') {
			this.totalPendingReports();
		} else if (id == 'TotalUnfitReports') {
			this.totalUnfitReports();
		} else if (id == 'BillingListReports') {
			this.getBillingListReports();
		}
	}


	companyList_dropdown: any = [];
	mhs_dashboard_company_dropdown() {
		/* this.apiService.mhs_dashboard_company_dropdown({}).subscribe((data: any) => {
			this.companyList_dropdown = data.company_list;
		}, (error) => {
			this.companyList_dropdown = [];
		}); */
		this.apiService.getCompanyDetails({}).subscribe((data: any) => {
			data.data = data.data.filter((comp: any) => comp.mhs_id)
			this.companyList_dropdown = data.data;
		}, (error) => {
			this.companyList_dropdown = [];
		});
	}

	ownAnalysisFilter: any = {
		symptom: null,
		sub_symptom: null,
		company_id: null,
		fleet_id: null,
		nationality: null,
		rank: null,
		age: "",
		start_date: this.apiService.getDefaultDateRange3Months(false).start_date,
		end_date: this.apiService.getDefaultDateRange3Months(false).end_date,
		case_status: null
	}
	getDateFormat(date) {
		let formattedDate: any = this.datePipe.transform(date, 'YYYY-MM-dd');
		return formattedDate;
	}

	// options
	showXAxis: boolean = true;
	showYAxis: boolean = true;
	gradient: boolean = false;
	showLegend: boolean = true;
	showXAxisLabel: boolean = true;
	yAxisLabel: string = 'Country';
	showYAxisLabel: boolean = true;
	xAxisLabel: string = 'Population';

	colorScheme = {
		domain: ['#5AA454', '#C7B42C', '#AAAAAA']
	};


	arc_width = 0.3;
	arc_width_thin = 0.2;
	pieChartLegendPosition: LegendPosition = LegendPosition.Below;
	letters = '0123456789ABCDEF';
	colorArr = [
		"#ff355e",
		"#ff9933",
		"#ffcc33",
		"#006b3c",
		"#ccff00",
		"#66ff66",
		"#aaf0d1",
		"#fd5b78",
		"#ff6037",
		"#ff9966",
		"#16d0cb",
		"#50bfe6",
		"#9c27b0",
		"#ee34d2",
		"#ff00cc"
	];

	getRandomColor() {
		let color = '#';
		for (var i = 0; i < 6; i++) {
			color += this.letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}
	no_candidates_per_day_loader = false;
	noOfCandidatesPerDayColors: any[] = [];
	no_candidates_per_day: any = [];


	mhs_dashboard_no_candidates_per_day() {
		this.no_candidates_per_day_loader = true;

		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date)
		};

		this.apiService.mhs_dashboard_no_candidates_per_day(filter).subscribe({
			next: (data: any) => {
				this.no_candidates_per_day_loader = false;
				this.no_candidates_per_day = data.noOfCasesPerDay || [];
				this.noOfCandidatesPerDayColors = this.no_candidates_per_day.map(candidate => ({
					name: candidate.name,
					value: "#ff6037"
				}));
			},
			error: () => {
				this.no_candidates_per_day_loader = false;
				this.no_candidates_per_day = [];
				this.noOfCandidatesPerDayColors = [];
			},
			complete: () => {

			}
		});
	}

	overview_countLoader = false;
	overview_count_data() {
		let filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date)
		};
		this.overview_countLoader = true;
		this.apiService.overview_count(filter).subscribe((data: any) => {
			this.overview_countLoader = false;
			this.totalNoOfTest = data.totalNoOfTest;
			this.completionTime = data.completionTime;
			this.prejoining = data.prejoining;
			this.prejoiningandpromotion = data.prejoiningandpromotion;
			this.totalNoOfMACITest = data.totalNoOfMACITest;
		}, (error) => {
			this.overview_countLoader = false;
			this.totalNoOfTest = null;
			this.completionTime = null;
			this.prejoining = null;
			this.prejoiningandpromotion = null;
			this.totalNoOfMACITest = null;

		})
	}

	rankList_dropdown: any = [];
	rankChart_data: any = [];
	rankDistributionLoader: any = false;
	rank_dropdown() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date),
			rank_id: this.cardsFilter.rank,
		};

		this.rankDistributionLoader = true;

		this.apiService.rank_dropdown_data(filter).subscribe(
			(data: any) => {
				this.rankDistributionLoader = false;
				const rankDistribution = data.rankDistribution || [];
				this.rankList_dropdown = rankDistribution;
				this.rankPieChartColors = [];

				// Calculate total rank
				const total_rank = rankDistribution.reduce((sum, rank) => sum + rank.value, 0);

				// Generate chart data with percentage values
				const chartData = rankDistribution.map((rank, index) => ({
					name: rank.name,
					value: ((rank.value / total_rank) * 100).toFixed(2),
				}));

				// Set chart colors
				this.rankPieChartColors = rankDistribution.map((rank, index) => ({
					name: rank.name,
					value: this.colorArr[index] || this.getRandomColor(),
				}));

				// Set chart data
				this.rankChart_data = chartData;

			},
			(error) => {
				console.error('Error fetching rank distribution data:', error);
				this.rankDistributionLoader = false; // Update to false on error too
				this.rankList_dropdown = [];
			}
		);
	}


	appointmentBarChartColors: any[] = [];
	appointment_chart_data: any = [];
	appointment_color_data: any[] = [];
	apptDistributionLoader: any = false;

	appointment_distribution_by_comp() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
		};
		this.apptDistributionLoader = true;
		this.apiService.get_apptts_distribution_by_comp(filter).subscribe({
			next: (data: any) => {
				const { companyWiseAppointment, companyList } = data;
				this.appointment_chart_data = companyWiseAppointment;
				this.appointment_color_data = companyList;
				this.appointmentBarChartColors = this.generateBarChartColors(companyList);
				this.apptDistributionLoader = false;
			},
			error: () => {
				this.apptDistributionLoader = false;
				this.appointment_chart_data = [];
				this.appointment_color_data = [];
				this.appointmentBarChartColors = [];
			},
		});
	}

	mapLoader = false;
	appointment_distribution_by_nation() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date),
		};
		this.mapLoader = true;
		this.apiService.get_apptts_distribution_by_nation(filter).subscribe({
			next: (data: any) => {
				this.mapLoader = false;
				this.markers = this.filterNationalities(data.nationality);
				setTimeout(() => {
					this.bindMap();
					this.addMapPoint();
				}, 200);
			},
			error: () => {
				this.mapLoader = false;
				setTimeout(() => {
					this.bindMap();
					this.addMapPoint();
				}, 200);
			},
		});
	}


	private filterNationalities(nationalities: any[]): any[] {
		return nationalities.filter((c: any) => {
			try {
				return !c.name.includes("(0)");
			} catch (error) {
				return false;
			}
		});
	}

	private generateBarChartColors(colorData: any[]): any[] {
		return colorData.map((name, index) => ({
			name: name,
			value: this.colorArr[index] || this.getRandomColor(),
		}));
	}

	private resetAppointmentData() {
		this.appointment_chart_data = [];
		this.appointmentBarChartColors = [];
	}

	bindMap() {
		$('#world-map').vectorMap({
			map: 'world_mill',
			series: {
				regions: [{
					values: gdpData,
					scale: ['#C8EEFF', '#0071A4'],
					normalizeFunction: 'polynomial'
				}]
			},
			markerStyle: {
				initial: {
					fill: '#F8E23B',
					stroke: '#383f47'
				}
			},

		});
	}

	addMapPoint() {
		this.removeAllMapPoint();
		var map = $('#world-map').vectorMap('get', 'mapObject');
		for (let i = 0; i < this.markers.length; i++) {
			this.markers[i].style = { fill: "#ff0034", stroke: "#ff0034", r: 3 };
		}
		map.addMarkers(this.markers, []);
	}

	removeAllMapPoint() {
		try {
			var map = $('#world-map').vectorMap('get', 'mapObject');
			map.removeAllMarkers();
		} catch (error) { }
	}

	report_status_pie_chart_data1: any[] = [];
	report_status_pie_chart_data2: any[] = [];
	report_status_pie_chart_data3: any[] = [];
	report_status_pie_chart_data4: any[] = [];
	case_closure_pie_chart_colors: any[] = [];
	reportPieChartColors1: any[] = [];
	reportPieChartColors2: any[] = [];
	reportPieChartColors3: any[] = [];
	reportPieChartColors4: any[] = [];
	keyReportStatusLoader: any = false;

	dashboard_report_status_pie_chart_data() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date),
		};
		this.keyReportStatusLoader = true;
		this.apiService.mhs_dashboard_pie_charts_data(filter).subscribe((data: any) => {
			this.keyReportStatusLoader = false;
			this.report_status_pie_chart_data1 = this.processReportChartData(data.invalidDistribution, this.reportPieChartColors1);
			this.report_status_pie_chart_data2 = this.processReportChartData(data.reportStatus, this.reportPieChartColors2);
			this.report_status_pie_chart_data3 = this.processReportChartData(data.appointmentStatus, this.reportPieChartColors3);
			this.report_status_pie_chart_data4 = this.processReportChartData(data.languagesUsed, this.reportPieChartColors4);

		}, (error) => {
			this.keyReportStatusLoader = false;
			this.resetChartData();
		});
	}

	private processReportChartData(distribution: any[], colors: any[]): any[] {
		const total = distribution.reduce((sum, item) => sum + item.value, 0);
		return distribution.map((item, index) => {
			const percentage = total ? ((item.value / total) * 100).toFixed(2) : '0.00';
			colors.push({ name: item.name, value: this.colorArr[index] || this.getRandomColor() });
			return { name: item.name, value: percentage };
		});
	}

	private resetChartData() {
		this.report_status_pie_chart_data1 = [];
		this.report_status_pie_chart_data2 = [];
		this.report_status_pie_chart_data3 = [];
		this.report_status_pie_chart_data4 = [];
	}

	rank_distribution_pie_chart1: any[] = [];
	rank_distribution_pie_chart_loader = false;;
	rank_distribution_pie_chart2: any[] = [];
	rank_distribution_pie_chart3: any[] = [];

	rank_distribution_pie_chart_data() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date),
			rank_id: this.cardsFilter.rank,
		};
		this.rank_distribution_pie_chart_loader = true;
		this.apiService.rank_distribution_pie_chart_data(filter).subscribe((data: any) => {
			this.rank_distribution_pie_chart_loader = false;
			this.rank_distribution_pie_chart1 = this.processChartData(data.rankPersonalityDistribution, this.rankPieChartColors1);
			this.rank_distribution_pie_chart2 = this.processChartData(data.rankClinicalDistribution, this.rankPieChartColors2);
			this.rank_distribution_pie_chart3 = this.processChartData(data.rankAgeDistribution, this.rankPieChartColors3);
		}, (error) => {
			this.rank_distribution_pie_chart_loader = false;
			this.rank_distribution_pie_chart1 = [];
			this.rank_distribution_pie_chart2 = [];
			this.rank_distribution_pie_chart3 = [];
		});
	}

	private processChartData(distribution: any[], colors: any[]): any[] {
		const total = distribution.reduce((sum, item) => sum + item.value, 0);
		return distribution.map((item, index) => {
			const percentage = total ? ((item.value / total) * 100).toFixed(2) : '0.00';
			colors.push({ name: item.name, value: this.colorArr[index] || this.getRandomColor() });
			return { name: item.name, value: percentage };
		});
	}

	deselectByIdClinical(id: any) {
		var arr: any = this.f.clinicalScale1.value;
		const index = arr.indexOf(id);
		arr.splice(index, 1);
		arr = [...arr];
	}

	mhs_personality_and_clinical_scales() {
		this.apiService.mhs_personality_and_clinical_scales().subscribe({
			next: (response: any) => {
				this.personalityScales = response.personalityScales || [];
				this.clinicalScales = response.clinicalScales || [];
			},
			error: (error) => {
				console.error('Error fetching personality and clinical scales:', error);
			},
			complete: () => {
				console.log('Personality and clinical scales data loaded successfully.');
			}
		});
	}


	personality_colors: any[] = [];
	keyPersonalityLoader: any = false;
	getPersonalityScales() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date),
			personalityScales: this.cardsFilter.personalityScale,
		};
		this.keyPersonalityLoader = true;
		this.apiService.getKeyPersonalityTraitsScreened(filter).subscribe((response: any) => {
			this.personalityScalesBar = this.processPersonalityData(response.result_Personality);
			this.keyPersonalityLoader = false;
		}, (error) => {
			this.keyPersonalityLoader = false;
			this.personalityScalesBar = [];
		});
	}

	private processPersonalityData(personalityScalesBar: any[]): any[] {
		const labels = ['0-75(STYLE)', '75-85(PREVALENT)', '86+(CAUTION)'];

		return personalityScalesBar.map(item => {
			item.series = item.series.map((value, index) => {
				this.personality_colors.push({
					name: labels[index],
					value: this.colorArr[index] || this.getRandomColor(),
				});
				return { name: labels[index], value: value };
			});
			return item;
		});
	}

	clinical_colors: any[] = [];
	keyClinicalLoader: any = false;
	getClinicalScales() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date),
			clinicalScales: this.cardsFilter.clinicalScale
		};
		this.keyClinicalLoader = true;
		this.apiService.getKeyClinicalTraitsScreened(filter).subscribe((response: any) => {
			this.keyClinicalLoader = false;
			this.clinicalScalesBar = this.processClinicalData(response.result_Clinical);
		}, (error) => {
			this.keyClinicalLoader = false;
			this.clinicalScalesBar = [];
		});
	}

	private processClinicalData(clinicalScalesBar: any[]): any[] {
		const labels = ['0-75(STYLE)', '75-85(PREVALENT)', '86+(CAUTION)'];

		return clinicalScalesBar.map(item => {
			item.series = item.series.map((value, index) => {
				const name = labels[index];
				this.clinical_colors.push({
					name: name,
					value: this.colorArr[index] || this.getRandomColor(),
				});
				return { name: name, value: value };
			});
			return item;
		});
	}

	/* feedColors1: any[] = [];
	feedColors2: any[] = [];
	feedColors3: any[] = [];
	feedColors4: any[] = []; */
	feedBackDataAll: any = [];
	feedbackLoader = false;
	feedColor = [
		{ name: "Strongly agree", value: "#3aa655" },
		{ name: "Agree", value: "#63b76c" },
		{ name: "Neither agree nor Disagree", value: "#9de093" },
		{ name: "Disagree", value: "#c95a49" },
		{ name: "Strongly Disagree", value: "#da2c43" },
	];
	/* getFeedbackDataOld() {
		let filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date)
		};
		this.feedbackLoader = true;
		this.apiService.getFeedbackData(filter).subscribe((response: any) => {
			this.feedbackLoader = false;
			let firstQuestion = response.allQuestions[0];
			let secondQuestion = response.allQuestions[1];
			let thirdQuestion = response.allQuestions[2];
			let fourthQuestion = response.allQuestions[3];
			let dd = ['Strongly agree', 'Agree', 'Neither agree nor Disagree', 'Disagree', 'Strongly Disagree'];
			let feedColor = ['#3aa655', '#63b76c', '#9de093', '#c95a49', '#da2c43'];


			const questions = [
				{ series: firstQuestion.series, feedColors: this.feedColors1 },
				{ series: secondQuestion.series, feedColors: this.feedColors2 },
				{ series: thirdQuestion.series, feedColors: this.feedColors3 },
				{ series: fourthQuestion.series, feedColors: this.feedColors4 }
			];

			for (let j = 0; j < firstQuestion.series.length; j++) {
				const nameValuePair = { name: dd[j], value: feedColor[j] };

				questions.forEach((question) => {
					question.series[j] = { name: dd[j], value: question.series[j] };
					question.feedColors.push(nameValuePair);
				});
			}
			this.feedbackbar1 = [firstQuestion];
			this.feedbackbar2 = [secondQuestion];
			this.feedbackbar3 = [thirdQuestion];
			this.feedbackbar4 = [fourthQuestion];
		}, (error) => {
			this.feedbackLoader = false;
			this.feedbackbar1 = [];
			this.feedbackbar2 = [];
			this.feedbackbar3 = [];
			this.feedbackbar4 = [];
		});
	} */

	getFeedbackData() {
		let filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.mhs_id : null,
			start_date: this.getDateFormat(this.cardsFilter.start_date),
			end_date: this.getDateFormat(this.cardsFilter.end_date)
		};
		this.feedbackLoader = true;
		this.apiService.getFeedbackData(filter).subscribe((response: any) => {
			console.log(response)
			this.feedbackLoader = false;
			this.feedBackDataAll = [];
			let answers = ['Strongly agree', 'Agree', 'Neither agree nor Disagree', 'Disagree', 'Strongly Disagree'];
			let allQuestions = response.allQuestions;
			for (let i = 0; i < allQuestions.length; i++) {
				let valArr: any = [];
				for (let j = 0; j < allQuestions[i].series.length; j++) {
					valArr.push({
						"name": answers[j],
						"value": allQuestions[i].series[j]
					})
				}
				let obj: any = {
					"name": allQuestions[i].name,
					"series": valArr
				};
				this.feedBackDataAll.push([obj]);
			}
			console.log(this.feedBackDataAll)
		}, (error) => {
			this.feedbackLoader = false;
			this.feedBackDataAll = [];
		});
	}

	company_period_wise_count_loader = false;
	company_period_wise_count: any = {};


	apptCntByPsychology: any[] = [];
	loadingApptCountByPsy = false;
	apptCntByPsyExcelLoader = false;
	apptCntByPsychologyExcelName = "Assesments By Psychologist.xlsx";
	apptCntByPsychologyHeaderName = "Assesments By Psychologist";
	getApptCntByPsychology() {
		this.loadingApptCountByPsy = true;
		this.apiService.simpleGetAPICall("AppointmentsCountByPsychology", this.dateFilter).subscribe((data: any) => {
			this.loadingApptCountByPsy = false;
			this.apptCntByPsychology = data;
		}, (error) => {
			this.loadingApptCountByPsy = false;
		});
	}
	getApptCntByPsychologyExcel(e: any) {
		e.stopPropagation();
		this.apptCntByPsyExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("AppointmentsCountByPsychologyExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.apptCntByPsyExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.apptCntByPsychologyExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.apptCntByPsyExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	AppointmentsNationalityDistribution: any[] = [];
	AppointmentsNationalityDistributionLoader = false;
	AppointmentsNationalityDistributionExcelLoader = false;
	AppointmentsNationalityDistributionExcelName = "Appointments By Nationality.xlsx";
	AppointmentsNationalityDistributionHeader = "Appointments By Nationality";
	appointmentsNationalityDistribution() {
		this.AppointmentsNationalityDistributionLoader = true;
		this.apiService.simpleGetAPICall("AppointmentsNationalityDistribution", this.dateFilter).subscribe((data: any) => {
			this.AppointmentsNationalityDistributionLoader = false;
			this.AppointmentsNationalityDistribution = data;
		}, (error) => {
			this.AppointmentsNationalityDistributionLoader = false;
		});
	}
	appointmentsNationalityDistributionExcelDownload(e: any) {
		e.stopPropagation();
		this.AppointmentsNationalityDistributionExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("AppointmentsNationalityDistributionExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.AppointmentsNationalityDistributionExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.AppointmentsNationalityDistributionExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.AppointmentsNationalityDistributionExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	MhsAppointmentsTotalData: any[] = [];
	MhsAppointmentsTotalDataLoader = false;
	MhsAppointmentsTotalDataExcelLoader = false;
	MhsAppointmentsTotalDataExcelName = "Appointments Total Data.xlsx";
	MhsAppointmentsTotalDataHeader = "Appointments Total Data";
	mhsAppointmentsTotalData() {
		this.MhsAppointmentsTotalDataLoader = true;
		this.apiService.simpleGetAPICall("MhsAppointmentsTotalData", this.dateFilter).subscribe((data: any) => {
			this.MhsAppointmentsTotalDataLoader = false;
			this.MhsAppointmentsTotalData = data;
		}, (error) => {
			this.MhsAppointmentsTotalDataLoader = false;
		});
	}
	mhsAppointmentsTotalDataExcelDownload(e: any) {
		e.stopPropagation();
		this.MhsAppointmentsTotalDataExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("MhsAppointmentsTotalDataExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.MhsAppointmentsTotalDataExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.MhsAppointmentsTotalDataExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.MhsAppointmentsTotalDataExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	BillableAppointmentsMHS: any[] = [];
	BillableAppointmentsMHSLoader = false;
	BillableAppointmentsMHSExcelLoader = false;
	BillableAppointmentsMHSExcelName = "Billable Appointments.xlsx";
	BillableAppointmentsMHSHeader = "Billable Appointments";
	billableAppointmentsMHS() {
		this.BillableAppointmentsMHSLoader = true;
		this.apiService.simpleGetAPICall("BillableAppointmentsMHS", this.dateFilter).subscribe((data: any) => {
			this.BillableAppointmentsMHSLoader = false;
			this.BillableAppointmentsMHS = data;
		}, (error) => {
			this.BillableAppointmentsMHSLoader = false;
		});
	}
	billableAppointmentsMHSExcelDownload(e: any) {
		e.stopPropagation();
		this.BillableAppointmentsMHSExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("BillableAppointmentsMHSExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.BillableAppointmentsMHSExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.BillableAppointmentsMHSExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.BillableAppointmentsMHSExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	TotalFlaggedForMSE: any[] = [];
	TotalFlaggedForMSELoader = false;
	TotalFlaggedForMSEExcelLoader = false;
	TotalFlaggedForMSEExcelName = "Total Flagged For MSE.xlsx";
	TotalFlaggedForMSEHeader = "Total Flagged For MSE";
	totalFlaggedForMSE() {
		this.TotalFlaggedForMSELoader = true;
		this.apiService.simpleGetAPICall("TotalFlaggedForMSE", this.dateFilter).subscribe((data: any) => {
			this.TotalFlaggedForMSELoader = false;
			this.TotalFlaggedForMSE = data;
		}, (error) => {
			this.TotalFlaggedForMSELoader = false;
		});
	}
	totalFlaggedForMSEExcelDownload(e: any) {
		e.stopPropagation();
		this.TotalFlaggedForMSEExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("TotalFlaggedForMSEExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.TotalFlaggedForMSEExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.TotalFlaggedForMSEExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.TotalFlaggedForMSEExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	TotalPendingReports: any[] = [];
	TotalPendingReportsLoader = false;
	TotalPendingReportsExcelLoader = false;
	TotalPendingReportsExcelName = "Total Pending Reports.xlsx";
	TotalPendingReportsHeader = "Total Pending Reports";
	totalPendingReports() {
		this.TotalPendingReportsLoader = true;
		this.apiService.simpleGetAPICall("TotalPendingReports", this.dateFilter).subscribe((data: any) => {
			this.TotalPendingReportsLoader = false;
			this.TotalPendingReports = data;
		}, (error) => {
			this.TotalPendingReportsLoader = false;
		});
	}
	totalPendingReportsExcelDownload(e: any) {
		e.stopPropagation();
		this.TotalPendingReportsExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("TotalPendingReportsExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.TotalPendingReportsExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.TotalPendingReportsExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.TotalPendingReportsExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	TotalUnfitReports: any[] = [];
	TotalUnfitReportsLoader = false;
	TotalUnfitReportsExcelLoader = false;
	TotalUnfitReportsExcelName = "Total Unfit Reports.xlsx";
	TotalUnfitReportsHeader = "Total Unfit Reports";
	totalUnfitReports() {
		this.TotalUnfitReportsLoader = true;
		this.apiService.simpleGetAPICall("TotalUnfitReports", this.dateFilter).subscribe((data: any) => {
			this.TotalUnfitReportsLoader = false;
			this.TotalUnfitReports = data;
		}, (error) => {
			this.TotalUnfitReportsLoader = false;
		});
	}
	totalUnfitReportsExcelDownload(e: any) {
		e.stopPropagation();
		this.TotalUnfitReportsExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("TotalUnfitReportsExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.TotalUnfitReportsExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.TotalUnfitReportsExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.TotalUnfitReportsExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	BillingListReports: any[] = [];
	BillingListReportsLoader = false;
	BillingListReportsExcelLoader = false;
	BillingListReportsExcelName = "Billing List Reports.xlsx";
	BillingListReportsHeader = "Billing List Reports";
	getBillingListReports() {
		this.BillingListReportsLoader = true;
		this.apiService.simpleGetAPICall("BillingListReports", this.dateFilter).subscribe((data: any) => {
			this.BillingListReportsLoader = false;
			this.BillingListReports = data;
		}, (error) => {
			this.BillingListReportsLoader = false;
		});
	}
	getBillingListReportsExcel(e: any) {
		e.stopPropagation();
		this.BillingListReportsExcelLoader = true;
		this.apiService.simpleGetAPICallArrayBuffer("BillingListReportsExcelDownload", this.dateFilter).subscribe(res => {
			let excelData: any = res.body;
			this.BillingListReportsExcelLoader = false;
			let blob = new Blob([excelData], { type: "application/ms-excel" });
			let fileName = this.BillingListReportsExcelName;
			FileSaver.saveAs(blob, fileName);
		}, (error) => {
			this.BillingListReportsExcelLoader = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	setCompany(comp: any) {
		if (comp) {
			sessionStorage.setItem("selectedCompanyFilter", JSON.stringify(comp));
		} else {
			sessionStorage.removeItem("selectedCompanyFilter");
		}
	}
}
